module.exports = __webpack_public_path__ + "img/ACR.3e170beb.png";